import React from "react";
import styled from "styled-components";
import { Header } from "..";
import { GlobalStyle } from "../../styled";

const LayoutContainer = styled.div`
  display: grid;
  grid-template-rows: 40px 1fr;
  height: 100vh;
  overflow: hidden;
`;

const Main = styled.main`
  display: flex;
  justify-content: center;
  overflow-y: auto;
`;

export const Layout = ({ children }) => {
  return (
    <LayoutContainer>
      <GlobalStyle />
      <Header />
      <Main>{children}</Main>
    </LayoutContainer>
  );
};
